import { render, staticRenderFns } from "./FormPart1.vue?vue&type=template&id=c20c4e10&scoped=true"
import script from "./FormPart1.vue?vue&type=script&lang=js"
export * from "./FormPart1.vue?vue&type=script&lang=js"
import style0 from "./FormPart1.vue?vue&type=style&index=0&id=c20c4e10&prod&lang=scss&scoped=true"
import style1 from "./FormPart1.vue?vue&type=style&index=1&id=c20c4e10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20c4e10",
  null
  
)

export default component.exports